export default __webpack_public_path__ + "static/media/KAVIAR_1.108e12cd.gif";